import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthErrorComponent } from 'projects/ais-common/src/public-api';
import { FormularComponent } from './formular/formular.component';

const routes: Routes = [
  {path: '', component: FormularComponent},
  {path: 'vsk', component: FormularComponent},
  {path: 'auth-error', component: AuthErrorComponent},
  {path: '**', component: FormularComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
